'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-case-declarations */
// Private
var injectPinterestScript = function injectPinterestScript() {
  var d = document;
  var f = d.getElementsByTagName('SCRIPT')[0];
  var p = d.createElement('SCRIPT');

  p.type = 'text/javascript';
  p.async = true;
  p.src = '//assets.pinterest.com/js/pinit.js';
  f.parentNode.insertBefore(p, f);
};

var getPinterestImgUrlAndDescription = function getPinterestImgUrlAndDescription() {
  var uri = window.location.href;
  var url = encodeURIComponent(uri);
  var isProduct = uri.search('/products/');
  var isTheMvmtBlog = uri.search('/the-mvmt/');

  var imgURL = '';
  var description = '';

  if (window.location.pathname === '/blogs/news/articles') {
    imgURL = encodeURIComponent($('#destination-1 img').attr('src'));
    description = $('.article-header-content p').text();
  } else if (window.location.pathname === '/pages/gift-guide') {
    imgURL = encodeURIComponent($('.gg-hero').css('background-image').replace('url("', '').replace('")', ''));
    description = 'MVMT Watches - ' + $('.gg-hero-subtitle').text();
  } else if (isProduct !== -1) {
    imgURL = encodeURIComponent($('.product-slider').find('img').first().attr('src'));
    description = 'MVMT ' + $('.prod-series').text() + $('.prod-name').text();
  } else if (isTheMvmtBlog !== -1) {
    var $allSections = $('main').find('section');
    var firstBackgroundImg = null;

    for (var i = 0; i < $allSections.length; i++) {
      if ($($allSections[i]).css('background-image') !== 'none') {
        firstBackgroundImg = $($allSections[i]).css('background-image').replace('url(', '').replace(')', '').replace(/"/gi, '');
        break;
      }
    }

    if (firstBackgroundImg === null) {
      var $allDivs = $('main').find('div');

      for (var _i = 0; _i < $allDivs.length; _i++) {
        if ($($allDivs[_i]).css('background-image') !== 'none') {
          firstBackgroundImg = $($allDivs[_i]).css('background-image').replace('url(', '').replace(')', '').replace(/"/gi, '');
          break;
        }
      }
    }

    if (firstBackgroundImg === null) {
      firstBackgroundImg = $('main').find('img').first().attr('src');
      firstBackgroundImg = firstBackgroundImg.replace('url(', '').replace(')', '').replace(/"/gi, '');
    }

    var uriBreakdown = uri.split('/');
    var lastIndex = uriBreakdown.length - 1;
    var title = uriBreakdown[lastIndex];

    imgURL = encodeURIComponent(firstBackgroundImg);
    description = 'MVMT -  ' + (title.charAt(0).toUpperCase() + title.slice(1).replace(/-/g, ' '));
  } else {
    imgURL = encodeURIComponent($('.product-photo-thumb.slick-active img').attr('src'));
    description = $('.product-description').text();
  }

  return { url: url, imgURL: imgURL, description: description };
};

var bindUIActions = function bindUIActions() {
  $(document).on('click', '.social-sharing-icon', function (_ref) {
    var self = _ref.currentTarget,
        event = (0, _objectWithoutProperties3.default)(_ref, ['currentTarget']);

    event.preventDefault();
    var network = $(self).data('network');

    switch (network) {
      case 'facebook':
        window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), 'Facebook', 'width=600, height=450, scrollbars=no');
        break;
      case 'twitter':
        window.open('http://www.twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href), 'Tweet', 'width=600, height=450, scrollbars=no');
        break;
      case 'pinterest':
        var _getPinterestImgUrlAn = getPinterestImgUrlAndDescription(),
            url = _getPinterestImgUrlAn.url,
            imgURL = _getPinterestImgUrlAn.imgURL,
            description = _getPinterestImgUrlAn.description;

        window.open('http://pinterest.com/pin/create/link/?url=' + url + '&media=' + imgURL + '&description=' + description, 'Pinterest', 'width=600, height=600, scrollbars=no');
        break;
      case 'google-plus':
        window.open('https://plus.google.com/share?url=' + encodeURIComponent(window.location.href), 'GooglePlus', 'width=680, height=450, scrollbars=no');
        break;
    }
  });
};

// Public / Init
var init = exports.init = function init() {
  bindUIActions();
  injectPinterestScript();
};

exports.default = {
  init: init
};